import React, { useEffect, useState } from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Tour } from './components/Tour';
import { Music } from './components/Music';
import { Videos } from './components/Videos';
import { Merch } from './components/Merch';
import { Footer } from './components/Footer';
export function App() {
  const [hash, setHash] = useState(window.location.hash);
  useEffect(() => {
    const handleHashChange = () => {
      setHash(window.location.hash);
      window.scrollTo(0, 0);
    };
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  return <div className="min-h-screen bg-brand-black text-brand-white font-sans selection:bg-brand-accent selection:text-brand-white" data-id="element-0" data-mp="2wjgpfdsj9neb">
      <Nav data-id="element-1" data-mp="28t4k8aooa4rf" />
      <main data-id="element-2" data-mp="28sl3gxardmez">
        {hash === '#tour' ? <div className="pt-20 min-h-screen" data-id="element-3" data-mp="23vci6nubd29i">
            <Tour data-id="element-4" data-mp="23ujlygszdv5m" />
          </div> : hash === '#music' ? <div className="pt-20 min-h-screen" data-id="element-5" data-mp="3ijxqiu0iq6lh">
            <Music data-id="element-6" data-mp="3ij64a9st9l7v" />
          </div> : hash === '#videos' ? <div className="pt-20 min-h-screen" data-id="element-7" data-mp="3mljat0fdtn5p">
            <Videos data-id="element-8" data-mp="3mk8710lxsfel" />
          </div> : hash === '#merch' ? <div className="pt-20 min-h-screen" data-id="element-9" data-mp="3rc9f0ac2njyt">
            <Merch data-id="element-10" data-mp="3rdki07xp0nov" />
          </div> : <>
            <Hero data-id="element-11" data-mp="3relvej26lm9r" />
          </>}
      </main>
      <Footer data-id="element-12" data-mp="682dxcgkib2" />
    </div>;
}